import React from 'react';
import { RenderAppropriate } from '../../internals/RenderAppropriate';

import { HeadingThreeStyle } from '../../styles/typography/heading.styles';

interface ThreeProps {
    children?: React.ReactNode;
    component?: React.ElementType;
    [key: string]: any;
}

interface ThreeComponent extends React.FC<ThreeProps> {
    Style?: typeof HeadingThreeStyle;
}

export const Three: ThreeComponent = ({ children, component: Component, ...rest }) =>
    RenderAppropriate(HeadingThreeStyle, rest, children, Component);

Three.Style = HeadingThreeStyle;
